import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import Collapse from '@material-ui/core/Collapse';

// --- Custom Icons ---
function MinusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 10, height: 10 }} {...props}>
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
    </SvgIcon>
  );
}

function PlusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 10, height: 10 }} {...props}>
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
    </SvgIcon>
  );
}

function CloseSquare(props) {
  return (
    <SvgIcon className="close" fontSize="inherit" style={{ width: 10, height: 10 }} {...props}>
      <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
    </SvgIcon>
  );
}

// --- TransitionComponent without animations ---
function TransitionComponent(props) {
  return <Collapse {...props} />;
}

TransitionComponent.propTypes = {
  in: PropTypes.bool,
};

// --- Styled TreeItem ---
const StyledTreeItem = withStyles(() => ({
  iconContainer: {
    '& .close': {
      opacity: 0.3,
    },
  },
  group: {
    marginLeft: 7,
    paddingLeft: 18,
    borderLeft: `1px dashed black`,
  },
  label: {
    fontSize: "0.8rem", 
  },
}))((props) => <TreeItem {...props} TransitionComponent={TransitionComponent} />);

const useStyles = makeStyles({
  root: {
    height: 'max-content',
    flexGrow: 1,
    maxWidth: 400,
    overflowY: 'auto'
  },
});

const renderTree = (node, parentId = "root") => {
  const nodeId = node.fieldId || node.messageId || node.eventId || parentId;
  const fieldLabel = !node.attributes?.optional && node.type === 12 ? `${node.fieldName} *` : node.fieldName;
  return (
    <StyledTreeItem id={parentId==="root" ? "node_item_root" : `node_item_${node.fieldName || node.evenName || "Unknown"}`} key={nodeId} nodeId={nodeId} label={
      <div style={{ display: "flex", gap: "8px", alignItems: "center", justifyContent: 'space-between' }}>
        <span id={"item_label"}>{ fieldLabel || node.evenName || "Unknown"}</span>
        {
          node.attributes &&
          <span id={"item_attribute"} style={{ color: "gray", fontStyle: "italic" }}>
            {node.readableType || ""}{node.attributes.collection? "[]" : ""}
          </span>
        }
      </div>
    }>
      {node.children &&
        node.children.length > 0 &&
        node.children.map((child, idx) => renderTree(child, `${nodeId}-${idx}`))}
    </StyledTreeItem>
  );
};

// --- TreeView ---
export default function CustomizedMaterialTreeView({style, message}) {
  const classes = useStyles();
  
  return (
    <TreeView
      id={"quickview_message_tree"}
      className={classes.root}
      style={{...style}}
      defaultExpanded={[message?.messageId]}
      defaultCollapseIcon={<MinusSquare />}
      defaultExpandIcon={<PlusSquare />}
      defaultEndIcon={<CloseSquare />}
    >
     {renderTree(message)}
    </TreeView>
  );
}
